import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "./HomeProduct.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HomeProduct = () => {
  const settings = {
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 700,
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerMode: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
        },
      },
    ],
  };

  return (
    <motion.div
      initial={{ y: 80, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div className="slider-outer">
        <div className="slider-container">
          <div className="page-heading-div">
            <h2 className="page-heading" style={{ color: "#ffffff" }}>
              OUR PRODUCTS
            </h2>
          </div>

          <Slider {...settings} className="custom-slick">
            {/* Product 1 */}
            <div className="slide-wrapper">
              <div className="slide-content">
                <img
                  src={require("../assets/products/ev-blue-ms.png")}
                  alt="Model Alpha"
                  className="slide-image"
                  loading="lazy"
                />
                <div className="spec-boxes">
                  <div className="spec-box spec-small-box">Battery: 135/140AH, 48V</div>
                  <div className="spec-box" style={{ fontSize: "15px", fontWeight: "700" }}>
                    VARDAAN MS 1250W DLX
                  </div>
                  <div className="spec-box spec-small-box">Speed: 40km/h</div>
                </div>
              </div>
            </div>

            {/* Product 2 */}
            <div className="slide-wrapper">
              <div className="slide-content">
                <img
                  src={require("../assets/products/ev-red-ms.png")}
                  alt="Model Beta"
                  className="slide-image"
                  loading="lazy"
                />
                <div className="spec-boxes">
                  <div className="spec-box spec-small-box">Battery: 135/140AH, 60V</div>
                  <div className="spec-box" style={{ fontSize: "15px", fontWeight: "700" }}>
                    VARDAAN MS 1250W DLX
                  </div>
                  <div className="spec-box spec-small-box">Speed: 40km/h</div>
                </div>
              </div>
            </div>

            {/* Product 3 */}
            <div className="slide-wrapper">
              <div className="slide-content">
                <img
                  src={require("../assets/products/ev-grey-ms.png")}
                  alt="Model Gamma"
                  className="slide-image"
                  loading="lazy"
                />
                <div className="spec-boxes">
                  <div className="spec-box spec-small-box">Battery: 105AH, 48V</div>
                  <div className="spec-box" style={{ fontSize: "15px", fontWeight: "700" }}>
                    VARDAAN MS 1250W DLX
                  </div>
                  <div className="spec-box spec-small-box">Speed: 40km/h</div>
                </div>
              </div>
            </div>

            {/* Product 4 */}
            <div className="slide-wrapper">
              <div className="slide-content">
                <img
                  src={require("../assets/products/ev-white-ss.png")}
                  alt="Model Delta"
                  className="slide-image"
                  loading="lazy"
                />
                <div className="spec-boxes">
                  <div className="spec-box spec-small-box">Battery: 135/140AH, 48V</div>
                  <div className="spec-box" style={{ fontSize: "15px", fontWeight: "700" }}>
                    VARDAAN SS 1250W DLX
                  </div>
                  <div className="spec-box spec-small-box">Speed: 40km/h</div>
                </div>
              </div>
            </div>

            {/* Product 5 */}
            <div className="slide-wrapper">
              <div className="slide-content">
                <img
                  src={require("../assets/products/ev-green-ss.png")}
                  alt="Model Epsilon"
                  className="slide-image"
                  loading="lazy"
                />
                <div className="spec-boxes">
                  <div className="spec-box spec-small-box">Battery: 135/140AH, 60V</div>
                  <div className="spec-box" style={{ fontSize: "15px", fontWeight: "700" }}>
                   VARDAAN SS 1250W DLX
                  </div>
                  <div className="spec-box spec-small-box">Speed: 40km/h</div>
                </div>
              </div>
              
            </div>

                 {/* Product 6 */}
            <div className="slide-wrapper">
              <div className="slide-content">
                <img
                  src={require("../assets/products/ev-red-ss.png")}
                  alt="Model Epsilon"
                  className="slide-image"
                  loading="lazy"
                />
                <div className="spec-boxes">
                  <div className="spec-box spec-small-box">Battery: 105AH, 48V</div>
                  <div className="spec-box" style={{ fontSize: "15px", fontWeight: "700" }}>
                  VARDAAN SS 1250W DLX
                  </div>
                  <div className="spec-box spec-small-box">Speed: 40km/h</div>
                </div>
              </div>
              
            </div>
          </Slider>
        </div>
      </div>
    </motion.div>
  );
};

export default HomeProduct;
